import React, { useMemo } from "react";
import {
  CharacterLetter,
  CharacterResult,
} from "common/character/dto/CharacterResult";
import CharacterRelateContainNavChar from "./CharacterRelateContainNavChar";
import { DivMarginTop } from "components/common/style/margin/DivMarginTop";
import styled from "styled-components";

type Props = {
  navLetterList: CharacterLetter[];
  navCharacterHandle: (navChar: CharacterResult | null) => void;
  navCharacter: CharacterResult | null;
};

const MAX_ROW_RELATE_LETTERS = 5;

const ContainNavCharGroup: React.FC<Props> = ({
  navLetterList,
  navCharacterHandle,
  navCharacter,
}) => {
  return (
    <>
      {navLetterList.map((navCharacterLetter: CharacterLetter, ind: number) => (
        <CharacterRelateContainNavChar
          navCharacterLetter={navCharacterLetter}
          navCharacterHandle={navCharacterHandle}
          navCharacterActive={
            navCharacter?.letter === navCharacterLetter.letter
          }
          key={`nav_letter_${ind}`}
        />
      ))}
    </>
  );
};

const CharacterContainNavCharList: React.FC<Props> = ({
  navLetterList,
  navCharacterHandle,
  navCharacter,
}) => {
  const { navLetterListGroup1, navLetterListGroup2 } = useMemo(() => {
    const n = navLetterList.length;
    // console.log("CharacterContainNavCharList - n", n);

    const navLetterListGroup1: CharacterLetter[] = navLetterList.slice(
      0,
      MAX_ROW_RELATE_LETTERS
    );
    const navLetterListGroup2: CharacterLetter[] =
      n > MAX_ROW_RELATE_LETTERS
        ? navLetterList.slice(MAX_ROW_RELATE_LETTERS, n)
        : [];

    return { navLetterListGroup1, navLetterListGroup2 };
  }, [navLetterList]);

  return (
    <DivMarginTop mt={1}>
      <DivGLetter mt={0}>
        <DivGroup1 mt={0}>
          <ContainNavCharGroup
            navCharacter={navCharacter}
            navLetterList={navLetterListGroup1}
            navCharacterHandle={navCharacterHandle}
          />
        </DivGroup1>
        <DivGroup2 mt={0}>
          <ContainNavCharGroup
            navCharacter={navCharacter}
            navLetterList={navLetterListGroup2}
            navCharacterHandle={navCharacterHandle}
          />
        </DivGroup2>
      </DivGLetter>
      <DivGLetter mt={1}>
        {navCharacter?.pronounce} {navCharacter?.meaning}
      </DivGLetter>
    </DivMarginTop>
  );
};

const DivGroup1 = styled(DivMarginTop)`
  display: flex;
  align-items: center;
  gap: 1rem;
  font-size: 2rem;
`;

const DivGroup2 = styled(DivMarginTop)`
  display: flex;
  gap: 1rem;
`;

const DivGLetter = styled(DivMarginTop)`
  display: flex;
  gap: 1rem;
`;

export default CharacterContainNavCharList;
